import Geometry from "@fae/source/utility/Geometry.js"

import kits from "../envkits.js"

const BUSH_1 = require("@fae/source/assets/images/ember-tactics/env/woods/BG-woods-24-wallMID-large.png")
const BUSH_2 = require("@fae/source/assets/images/ember-tactics/env/woods/BG-woods-26-wallLIGHT-large.png")

function getAngleBetweenPoints(a, b) {
    const angle = Math.atan2(b.y - a.y, b.x - a.x)
    return angle // for degrees: * (180 / Math.PI)
}

export default function GenerateEnvironmentArt({encounters, kit}) {
    kit = kit || kits["woods"] || {"colors": {}, "backgrounds": {}}
    const images = []
    images.push({
        "type": "polygon",
        "color": kit.colors.dark,
        "screenspace": "camera",
        "z": 0,
        "points": [
            {"x": 0, "y": 0},
            {"x": 16, "y": 0},
            {"x": 16, "y": 9},
            {"x": 0, "y": 9},
        ],
    })

    encounters.forEach((encounter) => {
        encounter.points.forEach((point, index) => {
            const a = encounter.points[(index + 0) % encounter.points.length]
            const b = encounter.points[(index + 1) % encounter.points.length]
            const c = encounter.points[(index + 2) % encounter.points.length]
            b.internalAngle = Geometry.direction(a, c)
            b.internalAngle = Geometry.rotate(b.internalAngle, 90)
            if(b.internalAngle.x < 0.1 && b.internalAngle.x > -0.1) b.internalAngle.x = 0
            if(b.internalAngle.y < 0.1 && b.internalAngle.y > -0.1) b.internalAngle.y = 0
        })
        encounter.min = {"x": Infinity, "y": Infinity}
        encounter.max = {"x": -Infinity, "y": -Infinity}
        encounter.points.forEach((point, index) => {
            if(point.x < encounter.min.x) encounter.min.x = point.x
            if(point.y < encounter.min.y) encounter.min.y = point.y
            if(point.x > encounter.max.x) encounter.max.x = point.x
            if(point.y > encounter.max.y) encounter.max.y = point.y
        })
        encounter.width = encounter.max.x - encounter.min.x
        encounter.height = encounter.max.y - encounter.min.y
        encounter.center = {
            "x": Math.min(encounter.min.x, encounter.max.x) + (Math.abs(encounter.min.x - encounter.max.x) / 2),
            "y": Math.min(encounter.min.y, encounter.max.y) + (Math.abs(encounter.min.y - encounter.max.y) / 2)
        }
        encounter.frame = {
            "x": encounter.center.x - (16 / 2),
            "y": encounter.center.y - (9 / 2)
        }

        images.push({
            "position": {"x": encounter.min.x + 0.01, "y": encounter.min.y + 0.01, "z": 11},
            "width": encounter.width - 0.02,
            "height": encounter.height - 0.02,
            "isGrid": true,
        })

        if(kit.backgrounds.farwall != undefined) {
            images.push({
                "url": kit.backgrounds.farwall,
                "position": {"x": encounter.center.x, "y": encounter.min.y + 0.5, "z": 0},
                "anchor": {"x": 0.5, "y": 1},
                "width": 16, "height": 9,
            })
        }
        if(kit.backgrounds.tallwall != undefined) {
            let tallwall = kit.backgrounds.tallwall
            if(kit.backgrounds.tallwall instanceof Array) {
                tallwall = tallwall.pop()
                kit.backgrounds.tallwall.unshift(tallwall)
            }
            images.push({
                "url": tallwall,
                "position": {"x": encounter.center.x, "y": encounter.min.y + 0.5, "z": 0}, // + 5.5
                "anchor": {"x": 0.5, "y": 1},
                "width": 16, "height": 18,
            })
        }
        if(kit.backgrounds.floor != undefined) {
            images.push({
                "url": kit.backgrounds.floor,
                "position": {"x": encounter.center.x, "y": encounter.min.y + 0.5, "z": 10},
                "anchor": {"x": 0.5, "y": 0},
                "width": 16, "height": 9,
            })
        }
        if(kit.backgrounds.truefloor != undefined) {
            images.push({
                "url": kit.backgrounds.truefloor,
                "position": {"x": encounter.center.x, "y": encounter.min.y, "z": 10},
                "anchor": {"x": 0.5, "y": 0},
                "width": 16, "height": 9,
            })
        }
        if(kit.backgrounds.nearwall != undefined) {
            images.push({
                "url": kit.backgrounds.nearwall,
                "position": {"x": encounter.center.x, "y": encounter.min.y - 1.35, "z": 35},
                "anchor": {"x": 0.5, "y": 0},
                "width": 16, "height": 9,
            })
        }
        if(kit.backgrounds.bignearwall != undefined) {
            images.push({
                "url": kit.backgrounds.bignearwall,
                "position": {"x": encounter.center.x, "y": encounter.min.y - 1.8, "z": 35},
                "anchor": {"x": 0.5, "y": 0},
                "width": 16, "height": 9,
            })
        }
        if(kit.backgrounds.smallnearwall != undefined) {
            images.push({
                "url": kit.backgrounds.smallnearwall,
                "position": {"x": encounter.center.x, "y": encounter.min.y + 0.2, "z": 35},
                "anchor": {"x": 0.5, "y": 0},
                "width": 16, "height": 9,
            })
        }

        // MAIN POLYGON
        const CUTOFF_HEIGHT = 0 // 0.5
        const outerpoints = encounter.points.map((point) => {
            // point = Geometry.add(point, Geometry.multiply(point.internalAngle, 1))
            return {
                "x": point.x,
                "y": Math.max(point.y, encounter.min.y + CUTOFF_HEIGHT),
            }
        })
        images.push({
            "type": "polygon",
            // "color": kit.colors.mid,
            "color": kit.colors.dark,
            "z": 62,
            "points": [
                {"x": encounter.frame.x + 0, "y": encounter.frame.y + 9.5},
                {"x": encounter.frame.x + 16, "y": encounter.frame.y + 9.5},
                {"x": encounter.frame.x + 16, "y": encounter.min.y + CUTOFF_HEIGHT},
                {"x": encounter.frame.x + 0, "y": encounter.min.y + CUTOFF_HEIGHT},
                ...outerpoints.map((point) => {
                    return {
                        "x": point.position?.x ?? point.x,
                        "y": point.position?.y ?? point.y,
                    }
                }),
                outerpoints[0],
                {"x": encounter.frame.x + 0, "y": encounter.min.y + CUTOFF_HEIGHT},
            ],
        })

        // DARKER POLYGON
        const outerpoints2 = encounter.points.map((point) => {
            point = Geometry.add(point, Geometry.multiply(point.internalAngle, 2.2))
            return {
                "x": point.x,
                "y": Math.max(point.y, encounter.min.y + CUTOFF_HEIGHT),
            }
        })
        images.push({
            "type": "polygon",
            "color": kit.colors.dark,
            "z": 64,
            "points": [
                {"x": encounter.frame.x + 0, "y": encounter.frame.y + 9.5},
                {"x": encounter.frame.x + 16, "y": encounter.frame.y + 9.5},
                {"x": encounter.frame.x + 16, "y": encounter.min.y + CUTOFF_HEIGHT},
                {"x": encounter.frame.x + 0, "y": encounter.min.y + CUTOFF_HEIGHT},
                ...outerpoints2.map((point) => {
                    return {
                        "x": point.position?.x ?? point.x,
                        "y": point.position?.y ?? point.y,
                    }
                }),
                outerpoints2[0],
                {"x": encounter.frame.x + 0, "y": encounter.min.y + CUTOFF_HEIGHT},
            ],
        })
        // outerpoints.forEach((point, index) => {
        //     if(point.y <= encounter.min.y) return
        //
        //     const currentPoint = outerpoints[(index + 0) % outerpoints.length]
        //     const nextPoint = outerpoints[(index + 1) % outerpoints.length]
        //     const angle = getAngleBetweenPoints(currentPoint, nextPoint)
        //
        //     const z = point.y < encounter.center.y ? 36 : 62
        //
        //     const vector = {
        //         "x": Math.cos(angle),
        //         "y": Math.sin(angle),
        //     }
        //
        //     images.push({
        //         "url": BUSH_1,
        //         "width": 1.3, "height": 1.3,
        //         "anchor": {"x": 0.5, "y": 0.5},
        //         "position": {"x": point.x, "y": point.y, "z": z},
        //         "rotation": index * 15,
        //         "index": index,
        //     })
        //     // const innerpoint = Geometry.add(point, Geometry.multiply(point.internalAngle, -0.05))
        //     const innerpoint = Geometry.add(point, (point.y < encounter.center.y) ? (point.x < encounter.center.x ? {"x": 0.05} : {"x": -0.05}) : {"y": -0.05})
        //     images.push({
        //         "url": BUSH_2,
        //         "width": 1.3, "height": 1.3,
        //         "anchor": {"x": 0.5, "y": 0.5},
        //         "position": {"x": innerpoint.x, "y": innerpoint.y, "z": z - 2},
        //         "rotation": index * 15,
        //         "index": index,
        //     })
        // })
    })

    return images
}
